// extracted by mini-css-extract-plugin
export default {"main":"Homepage_main__WVX0q","imageDiv":"Homepage_imageDiv__8GMhI","image":"Homepage_image__-qvBN","name":"Homepage_name__bRWKb","para":"Homepage_para__UbArk"};